<template>
  <modal 
    name="modal-chat" 
    :max-width="600" 
    :adaptive="true" 
    :height="'auto'" 
    :scrollable="false"
    id="chat_container" 
    @opened="opened" 
    @closed="closed"
  >
    <div 
      ref="appContainer"
      :style="chatContainerStyle"
      class="bg-white flex flex-col overflow-hidden md:h-[100dvh] transition-all duration-300"
    >
      <div v-if="showDisclaimer" class="absolute inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
        <div class="bg-white rounded-lg shadow-lg max-w w-full max-h-[70vh] flex flex-col pt-4">
          <div class="px-6 flex-1 overflow-y-auto mb-5">
            <span class="text-xs text-gray-700 leading-relaxed block" v-html="$root.public_info.chat_disclaimer ? (this.$root.currentLanguage == 'ru' ? $root.public_info.chat_disclaimer['ru'] : $root.public_info.chat_disclaimer['en']) : ''"></span>
              <div>
                  <a href="javascript:void(0)" @click="openPrivacyPolicy" class="ml-2 underline text-xs">{{ $root.getKeyWord('privacy_policy') }}</a>
              </div>
              <div>
                  <a class="ml-2 underline text-xs" @click="$modal.show('modal-personal-data'); $root.getPublicInformation('order_privacy')" href="javascript:void(0)"> {{ this.$root.currentLanguage == 'ru' ? 'Согласие на обработку персональных данных' : 'Personal Data Agreement'}} </a>
              </div>
          </div>
          <div class="p-6 pt-4 border-t">
            <div class="flex gap-3 justify-end">
                <button
                  @click="acceptDisclaimer"
                  class="py-1 px-4 w-24 rounded text-white bg-green-500 hover:bg-green-700 mr-4"
                >
                  {{ $root.getKeyWord('accept_btn') }}
                </button>
              <button 
                @click="cancelDisclaimer" 
                class="py-1 px-4 w-24 rounded text-white bg-gray-500 hover:bg-gray-700"
              >
                  {{ $root.getKeyWord('close') }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="flex gap-3 items-center px-4 border-b h-14 shrink-0 bg-white">
        <div class="flex gap-2 items-center w-full">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="text-gray-700 w-6 h-6">
            <path stroke-linecap="round" stroke-linejoin="round"
                  d="M20.25 8.511c.884.284 1.5 1.128 1.5 2.097v4.286c0 1.136-.847 2.1-1.98 2.193-.34.027-.68.052-1.02.072v3.091l-3-3c-1.354 0-2.694-.055-4.02-.163a2.115 2.115 0 01-.825-.242m9.345-8.334a2.126 2.126 0 00-.476-.095 48.64 48.64 0 00-8.048 0c-1.131.094-1.976 1.057-1.976 2.192v4.286c0 .837.46 1.58 1.155 1.951m9.345-8.334V6.637c0-1.621-1.152-3.026-2.76-3.235A48.455 48.455 0 0011.25 3c-2.115 0-4.198.137-6.24.402-1.608.209-2.76 1.614-2.76 3.235v6.226c0 1.621 1.152 3.026 2.76 3.235.577.075 1.157.14 1.74.194V21l4.155-4.155"/>
          </svg>
        </div>
        <select-language v-if="displaySelectLanguage" class="mx-4"></select-language>
        <div class="flex items-center space-x-4 w-full justify-end" v-else>
          <button v-if="chat_uuid" class="h-8 text-black focus:outline-none rounded-full  text-center flex space-x-1 items-center bg-stone-100 hover:bg-stone-200 px-2" @click="closeChat();">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4 text-current">
              <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15m3 0l3-3m0 0l-3-3m3 3H9"/>
            </svg>
          </button>

          <a href="javascript:void(0)" class="w-8 h-8 text-black bg-white focus:outline-none rounded-full  text-center inline-flex items-center shadow-md hover:shadow" @click="$modal.hide('modal-chat')">
            <svg width="48" height="48" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M21.2427 12.7574L12.7574 21.2426M12.7574 12.7574L21.2427 21.2426L12.7574 12.7574Z" stroke="#333333" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </a>
        </div>
      </div>
      <div ref="main" style="-webkit-overflow-scrolling: touch;" class="flex flex-col flex-1 overflow-y-auto overscroll-contain">
        <div class="flex flex-col gap-2 px-2" v-if="chat_uuid">
          <div class="chat_space w-full p-1"></div>
          <div v-for="message in messages" :key="message.id">
            <div class="flex gap-1" :class="[message.initiator_id === chat.initiator_id ? 'justify-end' : '']">
              <div class="flex items-end" :class="[message.initiator_id === chat.initiator_id ? 'order-1' : 'order-2']">
                <div class="flex flex-col text-xs max-w-xs mx-2 order-1 " :class="[message.initiator_id === chat.initiator_id ? 'items-end' : 'items-start']">
                  <div>
                    <div v-if="message.content == '*file*'">
                      <a :href="message.extra !== null && $root.getImage(message.extra.file)" target="_blank" class="py-1.5 px-2 text-sm flex font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-blue-700">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                          <path stroke-linecap="round" stroke-linejoin="round" d="M18.375 12.739l-7.693 7.693a4.5 4.5 0 01-6.364-6.364l10.94-10.94A3 3 0 1119.5 7.372L8.552 18.32m.009-.01l-.01.01m5.699-9.941l-7.81 7.81a1.5 1.5 0 002.112 2.13"></path>
                        </svg>
                        <span class="ml-1 text-xs">File</span>
                      </a>
                    </div>
                    <div v-else-if="message.content == '*voice*'" class="px-3 py-2 rounded-lg inline-block" :class="[message.initiator_id === chat.initiator_id ? 'rounded-br-none bg-blue-600' : 'rounded-bl-none bg-[#f1f6f8] border']">
                      <voice-message
                        :src="message.extra !== null ? $root.getImage(message.extra.file) : ''"
                        :duration="message.extra && message.extra.duration ? message.extra.duration : 0"
                        :sent="message.initiator_id === chat.initiator_id"
                        :color="$root.hotel.color"
                      ></voice-message>
                      <!-- <div v-if="message.extra && message.extra.transcription" class="mt-1.5 pt-1.5 border-t text-xs whitespace-pre-line" :class="[message.initiator_id === chat.initiator_id ? 'border-white/20 text-blue-50' : 'border-gray-200 text-gray-600']">
                        {{ message.extra.transcription }}
                      </div> -->
                    </div>
                    <div v-else class="px-4 py-2 rounded-lg inline-block" :class="[message.initiator_id === chat.initiator_id ? 'rounded-br-none bg-blue-600 text-white' : 'rounded-bl-none bg-[#f1f6f8] border text-black']">
                      <div v-if="message.extra && message.extra.pictures !== undefined" class="flex flex-wrap gap-2 mb-2 chat_message__pictures">
                        <img class="rounded" width="320" v-if="message.extra.pictures.length > 0" v-lazy="getLasyImage($root.getImage(message.extra.pictures[0].url))"/>
                      </div>
                      <div v-html="displayMessage(message.content)"></div>
                    </div>
                    <div v-if="message.extra && message.extra.buttons !== undefined" class="flex flex-wrap gap-2 mt-2">
                      <div v-for="item in message.extra.buttons">
                        <button @click="clickFlowButton(item)" class="border px-4 py-2 rounded-xl block hover:underline text-left" :style="{color: $root.hotel.color, 'border-color': $root.hotel.color}">{{ item.title }}</button>
                      </div>
                    </div>
                  </div>
                  <div class="text-[10px] w-full text-gray-300" :class="[message.initiator_id === chat.initiator_id ? 'text-right' : 'text-left']">{{ message.initiator.name }} - {{ message.created_at|timeFormat }}</div>
                </div>
              </div>
            </div>
          </div>
          <img v-if="isTyping && isActiveChatGpt" :src="require(`@/assets/image/typing.gif`)" alt="" class="object-contain top-0.5 w-8 h-8"/>
          <div id="bottom-chat">
          </div>
        </div>
        <div v-else>
          <chat-registration @startChat="startChat"></chat-registration>
        </div>
      </div>
      <div class="shrink-0 pb-[env(safe-area-inset-bottom)] bg-white">
        <div v-if="chatClosed" class="px-4 py-3 border-t border-amber-200 bg-amber-50 text-amber-800 text-sm text-center">
          {{ chatClosedText }}
        </div>
        <div v-else-if="chatNotice" :class="chatNotice.classes" class="px-4 py-2 border-t text-sm text-center">
          {{ chatNotice.text }}
        </div>
        <InputMessage
          v-if="chat && chat_uuid"
          :chat="chat"
          :content.sync="content"
          :loading.sync="loading_send_message"
          @send-message="sendMessage"
          @send-file-message="sendFileMessage"
          @send-voice-message="sendVoiceMessage"
          :isActiveChatGpt="isActiveChatGpt"
          :disabled="chatClosed"
          :activeVoiceMessage="activeVoiceMessage"
        />
      </div>
      <v-dialog/>
    </div>
  </modal>
</template>

<script>
import {eventBus} from '../../main';
import InputMessage from './input.message.vue';
import VoiceMessage from './VoiceMessage.vue';
import selectLanguage from '../layout/header/ArticleSelectLang.vue';
import chatRegistration from './registration.vue';
import {getAblyClient, disconnectAbly} from '../../ably';
import {Hooper, Pagination as HooperPagination, Slide} from 'hooper'
import 'hooper/dist/hooper.css';
import { getCentrifugoClient } from '../../centrifugo'; 

export default {
  components: {
    InputMessage,
    VoiceMessage,
    Hooper,
    Slide, 
    HooperPagination, 
    selectLanguage, 
    chatRegistration
  },

  data() {
    return {
      chat_uuid: (localStorage.getItem('chat-uuid') != undefined) ? localStorage.getItem('chat-uuid') : '',
      person_uuid: (localStorage.getItem('person-uuid') != undefined) ? localStorage.getItem('person-uuid') : '',
      is_hotel_guest: true,
      messages: null,
      chat: null,
      content: '',
      loading_send_message: false,
      visible: false,
      handelDrawer: null,
      name: '',
      room_number: '',
      pusher: null,
      isInitialized: false,
      subscribedChatUuid: null,
      ablyChannel: null,
      showDisclaimer: false,
      disclaimerAccepted: false,
      viewportHeight: window.innerHeight,
      isMobileChat: window.innerWidth < 768,
      isActiveChatGpt: false,
      isTyping: false,
      centrifugoSubscription: null,
      isChatOpenNow: true,
      isStaffOpenNow: true,
      isAiOpenNow: true,
      scheduleText: {},   // backend-localized STAFF/closed message ({ en, pl, ... })
      aiScheduleText: {}, // backend-localized AI-only message
      chatOpenTimer: null,
      activeVoiceMessage: false,
    }
  },

  computed: {
    displaySelectLanguage() {
      return window.location.pathname.indexOf('chat') > -1;
    },
    
    shouldShowDisclaimer() {
      return this.$root.hotel.is_active_chat === true &&
        process.env.VUE_APP_SERVER.toLowerCase() === 'ru' &&
        !this.disclaimerAccepted;
    },

    chatContainerStyle() {
      if(this.isMobileChat) {
        return { height: this.viewportHeight + 'px' };
      }
      return {};
    },
    isRuServer() {
        return process.env.VUE_APP_SERVER.toLowerCase() === 'ru';
    },

    // Single source of truth for availability — is_open from the chat status endpoint
    // (see fetchChatStatus). isChatOpenNow defaults to open, so a failed/absent status never blocks chat.
    chatClosed() {
      return !this.isChatOpenNow;
    },

    // Fully-closed banner text. Backend supplies the localized wording via schedule_text;
    // a generic localized string is used only if the backend omitted it.
    chatClosedText() {
      const text = this.localizedText(this.scheduleText);
      if (text) return text;

      const lang = this.$root.currentLanguage;
      const fallbackClosed = {
        ru: 'Сейчас чат не работает', en: 'The chat is currently closed', uz: 'Hozir chat ishlamaydi',
        de: 'Der Chat ist derzeit geschlossen', es: 'El chat está cerrado ahora', fr: 'Le chat est actuellement fermé',
        it: 'La chat è attualmente chiusa', tr: 'Sohbet şu anda kapalı', ua: 'Зараз чат не працює',
      };
      return this.$root.getKeyWord('chat_closed') || fallbackClosed[lang] || fallbackClosed.en;
    },

    chatNotice() {
      if (this.chatClosed) return null;
      if (this.isStaffOpenNow && this.isAiOpenNow) return null;
      if (this.isAiOpenNow) {
        const text = this.localizedText(this.aiScheduleText);
        return text ? { type: 'ai', text, classes: 'border-blue-200 bg-blue-50 text-blue-800' } : null;
      }
      if (this.isStaffOpenNow) {
        const text = this.localizedText(this.scheduleText);
        return text ? { type: 'staff', text, classes: 'border-green-200 bg-green-50 text-green-800' } : null;
      }
      return null;
    },
  },

  created() {
    // Initialize disclaimer state from localStorage
    this.disclaimerAccepted = localStorage.getItem('chat-disclaimer-accepted') === 'true';
    
    eventBus.$on('run-chat', data => {
      this.fetchChat();
    });

    eventBus.$on('open-chat', data => {
      this.$modal.show('modal-chat');
      
      // Check if disclaimer should be shown
      if (this.shouldShowDisclaimer) {
        this.$root.getPublicInformation('chat_disclaimer');
        this.showDisclaimer = true;
      } else {
        this.fetch();
        this.markAsRead();
      }
    });

    eventBus.$on('clear-chat', data => {
      this.$modal.hide('modal-chat');
      this.clearChat();
    });

    eventBus.$on('change-language', data => {
      this.restart();
    });

    window.addEventListener('resize', this.checkMobile);
  },

  destroyed() {
    this.stopChatOpenTimer();
    // window.removeEventListener("resize", this.resizeChatContainers);
    if (window.visualViewport) {
      window.visualViewport.removeEventListener('resize', this.updateViewportHeight);
      window.visualViewport.removeEventListener('scroll', this.updateViewportHeight);
    }
    window.removeEventListener('resize', this.checkMobile);
    
    // Unsubscribe from Ably channel
    if (this.ablyChannel) {
      this.ablyChannel.unsubscribe();
      this.ablyChannel = null;
    }
    if (this.centrifugoSubscription) { 
        this.centrifugoSubscription.unsubscribe(); 
        this.centrifugoSubscription = null; 
    }
    if (!this.isRuServer) {
        disconnectAbly();
    }
  },

  mounted() {
    this.subscribe()
  },

  methods: {
    async fetchChatStatus() {
      const uuid = this.$root.hotel && this.$root.hotel.uuid;
      if (!uuid) return;

      try {
        const url = process.env.VUE_APP_API_URL + 'public/chat/status/' + uuid;
        const response = await this.$http.get(url);
        const data = (response.data && response.data.data) || {};

        this.isChatOpenNow = data.is_open !== false;
        this.isStaffOpenNow = data.is_staff_open !== false;
        this.isAiOpenNow = data.is_ai_open !== false;
        this.activeVoiceMessage = data.active_voice_message !== false;
        // Banner wording is now backend-driven (already formatted, localized per language).
        // schedule_text = STAFF/closed message; ai_schedule_text = AI-only message.
        this.scheduleText = (data.schedule_text && typeof data.schedule_text === 'object') ? data.schedule_text : {};
        this.aiScheduleText = (data.ai_schedule_text && typeof data.ai_schedule_text === 'object') ? data.ai_schedule_text : {};
      } catch (e) {
        // Never block the chat on a status error — keep the last known state.
      }
    },

    // Picks the guest's language from a backend text map ({ en, pl, ... }), falling back to English.
    localizedText(obj) {
      if (!obj || typeof obj !== 'object') return '';
      const lang = this.$root.currentLanguage;
      return obj[lang] || obj.en || '';
    },

    startChatOpenTimer() {
      this.fetchChatStatus();
      this.stopChatOpenTimer();
      // Re-poll each minute so the state flips when crossing the open/close boundary.
      this.chatOpenTimer = setInterval(this.fetchChatStatus, 60000);
    },

    stopChatOpenTimer() {
      if (this.chatOpenTimer) {
        clearInterval(this.chatOpenTimer);
        this.chatOpenTimer = null;
      }
    },

    subscribe() {
        if (!this.chat) return;
        if (this.chat.uuid === this.subscribedChatUuid) return;

        // cleanup previous
        if (this.ablyChannel) { this.ablyChannel.unsubscribe(); this.ablyChannel = null; }
        if (this.centrifugoSubscription) { this.centrifugoSubscription.unsubscribe(); this.centrifugoSubscription = null; }

        const channelName = `chat-websocket-event.${this.chat.uuid}`;
        this.subscribedChatUuid = this.chat.uuid;

        if (this.isRuServer) {
            getCentrifugoClient().then(client => {
                const sub = client.newSubscription(channelName);
                sub.on('publication', (ctx) => this.handleChatMessage(ctx.data));
                sub.subscribe();
                this.centrifugoSubscription = sub;
            });
        } else {
            const ablyClient = getAblyClient();
            if (!ablyClient) return;
            this.ablyChannel = ablyClient.channels.get(channelName);
            this.ablyChannel.subscribe('chatWebsocketEvent', (message) => this.handleChatMessage(message.data));
        }
    },

    handleChatMessage(eventData) {
        const code = eventData?.code;
        const data = eventData?.data;

        if (!data) return;

        if (data.type == 'start-companion-typing' || data.type == 'end-companion-typing') {
            setTimeout(() => {
                document.getElementById("bottom-chat").scrollIntoView({behavior: 'smooth', block: 'center'});
            }, 200);
            return;
        }

        if (data.type === 'chat-message-created' && data.extra && data.extra.is_active_chat) {
            return false;
        }

        if (data.type == 'chat-message-created') {
            if (data.extra.initiator_uuid !== this.person_uuid) {
                try {
                    this.fetchSingle(data.chat_message_id);
                    eventBus.$emit('badges-bottom-navigation', { action: 'chat', count: 1 });
                } catch (e) {
                    console.error(e);
                }
            }
        }
    },

    checkMobile() {
      this.isMobileChat = window.innerWidth < 768;
    },

    updateViewportHeight() {
      if (!this.isMobileChat) return;

      // 1. Get exact height above keyboard
      if (window.visualViewport) {
        this.viewportHeight = window.visualViewport.height;
        
        // 2. CRITICAL: Force scroll to top to prevent body rubber-banding
        window.scrollTo(0, 0);
      } else {
        this.viewportHeight = window.innerHeight;
      }

      // 3. Scroll chat to bottom so user sees what they are typing
      this.scrollToBottom();
    },
    scrollToBottom() {
      // Small delay to allow UI to resize first
      setTimeout(() => {
          if(this.$refs.main) {
              this.$refs.main.scrollTop = this.$refs.main.scrollHeight;
          }
          if (document.getElementById("bottom-chat")) {
              document.getElementById("bottom-chat").scrollIntoView({behavior: 'smooth', block: 'center'});
          }
      }, 100);
    },
    opened() {
      this.startChatOpenTimer();

      document.querySelector('html').style.overflow = 'hidden';
      document.querySelector('body').style.overflow = 'hidden';
      document.querySelector('body').style.position = 'fixed';
      document.querySelector('body').style.width = '100%';

      if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', this.updateViewportHeight);
        window.visualViewport.addEventListener('scroll', this.updateViewportHeight);
      }

      this.updateViewportHeight();

      if (document.querySelector('#chat-messages'))
        document.querySelector('#chat-messages').style.height = Math.round(document.documentElement.clientHeight - 200) + 'px';

      if (document.querySelector('#chat-wrapper')) {
        document.querySelector('#chat-wrapper').style.width = Math.round(document.documentElement.width - 150) + 'px';
      }

      eventBus.$emit('badges-bottom-navigation', {
        action: 'chat',
        count : 0,
      });
    },
    openPrivacyPolicy() {
        this.$modal.show('modal-privacy-policy');
        this.$root.getPublicInformation('privacy_policy');
    },
    closed() {
      this.stopChatOpenTimer();

      document.querySelector('html').style.overflow = '';
      document.querySelector('body').style.overflow = '';
      document.querySelector('body').style.position = '';
      document.querySelector('body').style.width = '';

      // Stop Listening
      if (window.visualViewport) {
        window.visualViewport.removeEventListener('resize', this.updateViewportHeight);
        window.visualViewport.removeEventListener('scroll', this.updateViewportHeight);
      }
      // this.$root.freezeActivePageScroll(false);
      // document.querySelector('html').classList.remove('fixed');
      // document.querySelector('body').classList.remove('fixed');

      // window.removeEventListener("resize", this.resizeChatContainers);
    },

    async fetch() {
      await this.fetchChat();
      await this.fetchMessages();
    },

    async clearChat() {
      this.chat_uuid   = '';
      this.person_uuid = '';
      localStorage.removeItem('chat-uuid');
      localStorage.removeItem('person-uuid');
      this.closed()
    },

    async fetchChat() {
      if (this.chat_uuid === '')
        return;

      var url = process.env.VUE_APP_API_URL + 'public/chat/' + this.chat_uuid;

      try {
        let response = await this.$http.get(url, {params: {person_uuid: this.person_uuid}});

        var results  = response.data.data;
        this.isActiveChatGpt = results.is_active_chatgpt
        this.chat    = results;

        // this.subscribeAbly();
        this.subscribe()
      } catch (e) {
        localStorage.setItem('chat-uuid', '');
        localStorage.setItem('person-uuid', '');
        this.chat_uuid   = '';
        this.person_uuid = '';
      }
    },

    async fetchMessages() {
      if (this.chat_uuid === '')
        return;

      var last_message_id = localStorage.getItem('chat-last-message-id') !== undefined ? localStorage.getItem('chat-last-message-id') : null;

      var url = process.env.VUE_APP_API_URL + 'public/chat/' + this.chat_uuid + '/messages?last-message-id=' + last_message_id;

      let response  = await this.$http.get(url);
      var results   = response.data.data;
      this.messages = results;

      setTimeout(() => {
        document.getElementById("bottom-chat").scrollIntoView({behavior: 'smooth', block: 'center'});
      }, 300);
    },

    async fetchSingle(id) {
      var url = process.env.VUE_APP_API_URL + 'public/chat/' + this.chat_uuid + '/messages/' + id;

      let response = await this.$http.get(url);
      var result = response.data.data;
      var has_new_message = false;
      if (this.messages !== null && this.messages.length > 0) {
        if (this.messages.filter(item => item.id == result.id).length == 0) {
          has_new_message = true;
        }
      } else {
        has_new_message = true;
      }

      if (has_new_message) {
        this.messages.push(result);
        setTimeout(() => {
          document.getElementById("bottom-chat").scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'start'});
        }, 300);
      }
    },

    async startChat(chat_uuid, person_uuid) {
      this.chat_uuid   = chat_uuid;
      this.person_uuid = person_uuid;

      this.$nextTick(() => {
        this.fetch();
      });
    },

    closeChat() {
      var result = this.$modal.show('dialog', {
        //title: 'The standard Lorem Ipsum passage',
        text   : this.$root.getKeyWord('leave_chat'),
        buttons: [
          {
            title  : this.$root.getKeyWord('no'),
            handler: () => {
              this.$modal.hide('dialog')
            }
          },
          {
            title  : this.$root.getKeyWord('yes'),
            handler: () => {
              this.chat_uuid = null;
              if (this.messages && this.messages.length > 0)
                localStorage.setItem('chat-last-message-id', this.messages[this.messages.length - 1].id);

              localStorage.removeItem('chat-uuid');

              this.$modal.hide('dialog');
            }
          }
        ]
      });
    },

    async restart() {
      if (!this.chat)
        return;

      var url = process.env.VUE_APP_API_URL + 'public/chat/' + this.chat.uuid + '/restart';

      /** TODO: hotel id need to put **/
      await this.$http.post(url, {
        lang: this.$root.currentLanguage,
      });
    },

    async sendMessage() {
        if (this.chatClosed) {
            return false;
        }

        if (this.content.length == 0) {
            return false;
        }

        const userContent = this.content; 
        let optimisticMessage = null;
        let initiatorName = 'Guest'; 
        let confirmedUserId = this.chat.initiator_id;

        // 1. Optimistic Update Logic
        if (this.isActiveChatGpt) {
            const tempId = `temp-${Date.now()}-${Math.random().toString(36).slice(2)}`;

            optimisticMessage = {
                id: tempId,
                chat_id: this.chat.id,
                content: userContent,
                initiator_id: confirmedUserId,
                initiator: {
                    id: confirmedUserId,
                    name: initiatorName
                },
                created_at: new Date().toISOString(),
                status_id: 'pending',
                type_id: 'common',
                is_deleted: false,
                read_at: null,
                scheduled_at: null,
                mchannel_id: 'web',
                logs: "[]",
                has_buttons: false,
                has_media: false,
            };

            if (this.messages !== null) {
                this.messages.push(optimisticMessage);
            } else {
                this.messages = [optimisticMessage];
            }

            this.content = '';
            this.scrollToBottom();
        }

        this.isTyping = true
        this.loading_send_message = true;

        try {
            var url = process.env.VUE_APP_API_URL + "public/chat/" + this.chat.uuid + '/messages';
            let response = await this.$http.post(url, {
                content: userContent,
                person_uuid: this.person_uuid,
                lang: this.$root.currentLanguage,
            });

            var result = response.data.data; 
            console.log('result: ', result)

            // 2. Confirmation/Replacement Logic
            if (this.isActiveChatGpt && optimisticMessage) {
            
              // A. Replace the optimistic message with the REAL result
              const optimisticIndex = this.messages.findIndex(m => m.id === optimisticMessage.id);
              if (optimisticIndex !== -1) {
                  console.log('messages: ', this.messages)
                  this.messages.splice(optimisticIndex, 1, result);
              }

              // B. Add the Bot's Reply
              if (result.chatpgt_answer) {
                  let botMessage =  result.chatpgt_answer
                  if (!botMessage.initiator) {
                      botMessage.initiator = {
                          id: botMessage.initiator_id, // Use the ID provided by the API
                          name: 'AI Assistant' // Set the name for the UI
                      };
                  }

                  console.log('botMessage', botMessage)

                  // Check for duplicates before adding bot message
                  const botIndex = this.messages.findIndex(m => m.id === result.answer_chatgpt_id);

                  if (botIndex === -1) {
                      this.messages.push(botMessage);
                  }
              }

              this.scrollToBottom(); 
            } else {
                await this.fetchSingle(result.id);
                this.content = '';
            }
        } catch (error) {
            if (this.isActiveChatGpt && optimisticMessage) {
                const index = this.messages.findIndex(m => m.id === optimisticMessage.id);
                if (index !== -1) {
                    this.messages.splice(index, 1);
                }
                this.content = userContent;
            }
        } finally {
            this.loading_send_message = false;
            this.isTyping = false;
        }
    },

    async sendCommandMessage(message, command) {
      this.loading_send_message = true;

      var url      = process.env.VUE_APP_API_URL + "public/chat/" + this.chat.uuid + '/messages';
      let response = await this.$http.post(url, {
        content    : message,
        command    : command,
        person_uuid: this.person_uuid,
        lang       : this.$root.currentLanguage,
      });

      var results = response.data.data;

      this.messages.push(results);
      this.content = '';

      this.loading_send_message = false;

      setTimeout(() => {
        document.getElementById("bottom-chat").scrollIntoView({behavior: 'smooth', block: 'center'});
      }, 200);
    },

    async sendFileMessage(file) {
      if (this.chatClosed) {
        return false;
      }

      this.loading_send_message = true;

      var url      = process.env.VUE_APP_API_URL + "public/chat/" + this.chat.uuid + '/messages';
      let response = await this.$http.post(url, {
        content    : "*file*",
        extra      : {file: file},
        person_uuid: this.person_uuid
      });

      var results = response.data.data;

      this.messages.push(results);
      this.content = '';

      this.loading_send_message = false;

      setTimeout(() => {
        document.getElementById("bottom-chat").scrollIntoView({behavior: 'smooth', block: 'center'});
      }, 200);
    },

    async sendVoiceMessage(file, duration) {
      if (this.chatClosed) {
        return false;
      }

      const confirmedUserId = this.chat.initiator_id;
      const tempId = `temp-${Date.now()}-${Math.random().toString(36).slice(2)}`;

      // Optimistic update: show the voice message immediately so it can't be
      // out-ordered by the bot reply that arrives over the websocket while the
      // (synchronous) request is still in flight.
      const optimisticMessage = {
        id: tempId,
        chat_id: this.chat.id,
        content: '*voice*',
        extra: {file: file, duration: duration},
        initiator_id: confirmedUserId,
        initiator: {id: confirmedUserId, name: 'Guest'},
        created_at: new Date().toISOString(),
        status_id: 'pending',
        type_id: 'common',
        is_deleted: false,
        read_at: null,
        scheduled_at: null,
        mchannel_id: 'web',
        logs: "[]",
        has_buttons: false,
        has_media: true,
      };

      if (this.messages !== null) {
        this.messages.push(optimisticMessage);
      } else {
        this.messages = [optimisticMessage];
      }
      this.scrollToBottom();

      this.isTyping = true;
      this.loading_send_message = true;

      try {
        var url      = process.env.VUE_APP_API_URL + "public/chat/" + this.chat.uuid + '/messages';
        let response = await this.$http.post(url, {
          content    : "*voice*",
          extra      : {file: file, duration: duration},
          person_uuid: this.person_uuid,
          lang       : this.$root.currentLanguage,
        });

        var result = response.data.data;

        // Replace the optimistic message with the confirmed one.
        const optimisticIndex = this.messages.findIndex(m => m.id === tempId);
        if (optimisticIndex !== -1) {
          this.messages.splice(optimisticIndex, 1, result);
        }

        // Append the bot reply (dedup against the websocket copy).
        if (this.isActiveChatGpt && result.chatpgt_answer) {
          let botMessage = result.chatpgt_answer;
          if (!botMessage.initiator) {
            botMessage.initiator = {id: botMessage.initiator_id, name: 'AI Assistant'};
          }
          const botIndex = this.messages.findIndex(m => m.id === result.answer_chatgpt_id);
          if (botIndex === -1) {
            this.messages.push(botMessage);
          }
        }

        this.scrollToBottom();
      } catch (error) {
        const index = this.messages.findIndex(m => m.id === tempId);
        if (index !== -1) {
          this.messages.splice(index, 1);
        }
      } finally {
        this.loading_send_message = false;
        this.isTyping = false;
      }
    },

    close() {
      this.visible = false;
    },

    displayMessage(text) {
      text = text.replace(/\n/g, '<br />');
      return this.replaceURLWithHTMLLinks(text);
    },

    replaceURLWithHTMLLinks(text) {
      var exp     = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
      var replace = text.replace(exp, "<a class='text-blue-500' href='$1'>$1</a>");
      return replace;
    },

    subscribeAbly() {
      if (!this.chat) {
        return;
      }

      if (this.chat.uuid === this.subscribedChatUuid) {
        return;
      }

      // Unsubscribe from previous channel if exists
      if (this.ablyChannel) {
        this.ablyChannel.unsubscribe();
        this.ablyChannel = null;
      }

      const ablyClient = getAblyClient();
      if (!ablyClient) {
        console.error('Ably client not initialized. Please set VUE_APP_ABLY_API_KEY in your environment variables.');
        return;
      }

      // Channel name format: chat-websocket-event.{chatUUID}
      const channelName = `chat-websocket-event.${this.chat.uuid}`;
      this.ablyChannel = ablyClient.channels.get(channelName);

      this.subscribedChatUuid = this.chat.uuid;

      // Subscribe to chatWebsocketEvent
      this.ablyChannel.subscribe('chatWebsocketEvent', (message) => {
        // Backend sends: { data: $event->data, code: $event->code }
        const eventData = message.data;
        const code = eventData?.code;
        const data = eventData?.data;

        if (!data) {
          return;
        }

        // Handle typing indicators
        if (data.type == 'start-companion-typing') {
          setTimeout(() => {
            document.getElementById("bottom-chat").scrollIntoView({behavior: 'smooth', block: 'center'});
          }, 200);
          return;
        }

        if (data.type == 'end-companion-typing') {
          setTimeout(() => {
            document.getElementById("bottom-chat").scrollIntoView({behavior: 'smooth', block: 'center'});
          }, 200);
          return;
        }

        // Skip active chat messages
        if (
          data.type === 'chat-message-created' &&
          data.extra &&
          data.extra.is_active_chat
        ) {
          return false;
        }          

        // Handle new chat messages
        if (data.type == 'chat-message-created') {
          if (data.extra.initiator_uuid !== this.person_uuid) {
            try {
              this.fetchSingle(data.chat_message_id);

              eventBus.$emit('badges-bottom-navigation', {
                action: 'chat',
                count : 1,
              });
            } catch (e) {
              console.error(e);
            }
          }
        }
      });
    },

    async markAsRead() {
      if (this.chat == null)
        return;

      var url      = process.env.VUE_APP_API_URL + "public/chat/" + this.chat.uuid + '/mark-as-read';
      var response = await this.$http.post(url, {person_uuid: this.person_uuid});

      eventBus.$emit('badges-bottom-navigation', {
        action: 'chat',
        count : 0,
      });
    },

    resizeChatContainers() {
      if (document.querySelector('#chat-messages'))
        document.querySelector('#chat-messages').style.height = Math.round(document.documentElement.clientHeight - 200) + 'px';

      if (document.querySelector('#chat-wrapper')) {
        document.querySelector('#chat-wrapper').style.width = Math.round(document.documentElement.width - 150) + 'px';
      }
    },

    clickFlowButton(item) {
      if (item.msg_id && item.msg_id.length > 0) {
        this.sendCommandMessage(item.title, item.msg_id);
      }
      if (item.link) {
        window.open(item.link, '_blank');
      }
    },

    acceptDisclaimer() {
      // Save acceptance to localStorage
      localStorage.setItem('chat-disclaimer-accepted', 'true');
      // Update reactive data property
      this.disclaimerAccepted = true;
      this.showDisclaimer = false;
      
      // Continue with normal chat initialization
      this.fetch();
      this.markAsRead();
    },

    cancelDisclaimer() {
      this.showDisclaimer = false;
      // Close the chat modal
      this.$modal.hide('modal-chat');
    }
  }
}
</script>

<style>
@supports (-webkit-touch-callout: none) {
  #chat_container .vm--modal {
    border-radius: 0 !important;
  }
}

@supports not (-webkit-touch-callout: none) {
  #chat_container .vm--modal {
    border-radius: 0 !important;
    top: 0px !important;
  }
}

#chat_container .vm--modal {
  height: 100dvh !important;
  min-height: auto !important;
}

#chat_container .vue-dialog {
  border-radius: 13px !important;
}

.chat_message__pictures .hooper {
  width: 320px !important;
}

.chat_message__pictures .hooper-slide {
  width: 320px !important;
}

.chat_message__pictures .hooper-slide img {
  width: 320px !important;
}

@media (min-width: 481px) {
  .chat_message__pictures .hooper {
    width: 420px !important;
  }

  .chat_message__pictures .hooper-slide {
    width: 420px !important;
  }


  .chat_message__pictures .hooper-slide img {
    width: 420px !important;
  }
}

[data-hs-tab].active.hs-tab-active\:shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

[data-hs-tab].active.hs-tab-active\:text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity));
}

[data-hs-tab].active.hs-tab-active\:bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}

/***NEWWW */
/* Force the modal wrapper to be transparent and full screen on mobile */
#chat_container .vm--modal {
  /* background-color: transparent !important; */
  box-shadow: none !important;
  /* On mobile, we let our internal DIV handle the height via JS */
  height: 100% !important; 
  top: 0 !important;
  bottom: 0 !important;
}

/* On Desktop, restore standard modal look */
@media (min-width: 768px) {
  #chat_container .vm--modal {
    height: auto !important;
    background-color: white !important;
    box-shadow: 0 20px 60px -2px rgba(27, 33, 58, 0.4) !important;
  }
}

#chat_container a {
  word-break: break-all;
}
</style>
